import { deepCopy } from '@utils/common';
import { QUES_SECTIONS_SEQ } from '@model/questionmaires/questionnaire';
import { QUES_COMPONENT_TYPES } from '@model/questionmaires/componentTypes';
import { calculateScore } from './caculateScore';
import { genKey } from 'draft-js';
import {
  SECTION_LEVEL_PREFIX,
  SECTION_SUMMARY_PREFIX,
} from '@modules/questionnaires/complexity/sections/overall/components/gaugeCard';

const ANSWERTYPE = {
  [QUES_COMPONENT_TYPES.RADIO]: 'choice',
  [QUES_COMPONENT_TYPES.CHECKBOX]: ['choices', 'other'],
  [QUES_COMPONENT_TYPES.SCALE]: 'choice',
  [QUES_COMPONENT_TYPES.INPUT]: 'choice',
  [QUES_COMPONENT_TYPES.MULTIRADIO]: 'choiceCollection',
  [QUES_COMPONENT_TYPES.EXECUTION]: ['choice', 'text'],
  [QUES_COMPONENT_TYPES.SCALEWITHINPUT]: 'choice',
  [QUES_COMPONENT_TYPES.RADIOWITHINPUT]: ['choice', 'text'],
};

export const hasValue = (str, v) => {
  const s = str.split(';');
  return s.find((itm, idx) => itm.toLowerCase() === v.toLowerCase());
};

export const getOptionFromValue = (optionCriteriaArr, answerValue) => {
  if (typeof optionCriteriaArr === 'string') {
    optionCriteriaArr = JSON.parse(optionCriteriaArr);
  }
  return optionCriteriaArr.find((itm, idx) =>
    hasValue(itm.criteria, answerValue),
  );
};

export const getOptionFromIndex = (optionCriteriaArr, answerIndex) => {
  if (typeof optionCriteriaArr === 'string') {
    optionCriteriaArr = JSON.parse(optionCriteriaArr);
  }
  return optionCriteriaArr?.find((itm, idx) =>
    itm.index.find((item, i) => item === answerIndex),
  );
};

export const getOptionFromLevel = (optionCriteriaArr, level) => {
  if (typeof optionCriteriaArr === 'string') {
    optionCriteriaArr = JSON.parse(optionCriteriaArr);
  }
  return optionCriteriaArr.find((item, idx) => item.level === level) || {};
};

// export const getLevelFromAnswerValue = (optionCriteriaArr, answer) =>
//   optionCriteriaArr.find((item, idx) => item.level === level);

export const getAnswerValue = (model, answer) => {
  let res;
  if (model.type === 'scalebar') {
    const { extremeTexts } = model.options;
    res = extremeTexts[answer - 1];
  } else if (model.type === 'checkbox') {
    res = answer.map((itm, idx) => model.options[itm - 1].text);
  } else if (model.type === 'multiRadio') {
    res = answer.map((itm, idx) => model.options[idx].options[itm - 1]?.text);
  } else if (model.type === 'execution') {
    // res = model.options.radioText[answer - 1].text;
    return {};
  } else {
    res = model.options[answer - 1].text;
  }
  return res;
};

export const formatStrategyData = (originData, complexityModel) => {
  let data, models;
  if (!originData) {
    return null;
  }
  data = deepCopy(originData);
  models = deepCopy(complexityModel);
  const executionAnswerArr = [];
  const executionRiskTextArr = [];
  const executionFullRiskTextArr = []; // for BPSI-risk-mitigation
  const { subSectionComplexity, level, sectionNum } = data;
  subSectionComplexity &&
    subSectionComplexity.forEach((item, idx) => {
      if (sectionNum === 5 && idx === 1) {
        item.questionComplexity.forEach((obj) => {
          // for BPSI-risk-mitigation
          if (Array.isArray(obj.riskMitigation)) {
            obj.riskMitigation.forEach((fullRiskMit) => {
              fullRiskMit.seqNum = obj.seqNum;
            });
            executionFullRiskTextArr.push(obj.riskMitigation);
          }

          obj.riskMitigation.forEach((riskText) => {
            if (obj.level === riskText.level) {
              executionRiskTextArr.push({
                level: riskText.level,
                text: riskText.text,
                seqNum: obj.seqNum,
              });
            }
          });
        });
        item.fullRiskMitigation = executionFullRiskTextArr;
        item.riskMitigation = executionRiskTextArr;

        // console.log(subSectionComplexity,"subSectionComplexity99999999")
        // item.riskMitigation = item.questionComplexity.map((risks) =>
        //   risks.riskMitigation
        //     .filter((risk) => (risk.level = item.level))
        //     .map((itm) => itm.text),
        // );
      }
      item.questionComplexity.forEach((question, i) => {
        models.forEach((model, index) => {
          if (model.sequenceNumber === question.seqNum) {
            model.level = question.level;
            model.seqNum = question.seqNum;
            const {
              optionText: optionCriteriaArr,
              level,
              riskMitigation: riskMitigationaArr,
            } = question;
            if (optionCriteriaArr) {
              model.optionCriteriaArr = optionCriteriaArr;
              model.originAnswer = question.answer;
              model.answer =
                question.answer.choice ||
                question.answer.choices ||
                question.answer.choiceCollection ||
                question.answer;
              if (model.isCollapse) {
                executionAnswerArr.push({
                  ...question.answer,
                  seqNum: model.seqNum,
                });
                // executionRiskTextArr.push({
                //   ...question.riskMitigation,
                //   seqNum: model.seqNum,
                // });
              }
              model.answerValue = getAnswerValue(model, model.answer);
              let option = '';

              if (model.seqNum === 1 || model.seqNum === 2) {
                option = getOptionFromIndex(optionCriteriaArr, model.answer);
              } else {
                // for complexity-BPSI collapse
                option = getOptionFromLevel(optionCriteriaArr, model.level);
                if (model.sequenceNumber === 32) {
                  option.text = {
                    'ERP (Enterprise Resource Planning)': option?.text,
                    key: 'ERP (Enterprise Resource Planning)',
                  };
                }
                if (model.sequenceNumber === 33) {
                  option.text = {
                    'CRM (Customer Relationship Management)': option?.text,
                    key: null,
                  };
                }
                if (model.sequenceNumber === 34) {
                  option.text = {
                    'HCM (Human Capital Management)': option?.text,
                    key: null,
                  };
                }
                if (model.sequenceNumber === 35) {
                  option.text = {
                    'Marketing Automation': option?.text,
                    key: null,
                  };
                }
                if (model.sequenceNumber === 36) {
                  option.text = {
                    'SCM (Supply Chain Management)': option.text,
                    key: null,
                  };
                }
              }

              model.optionCriteria = option && option.criteria;
              model.optionText = option && option.text;
              model.optionLevel = option && option.level;
              model.index = option && option.index;
              model.score = calculateScore(model);
            }
            if (riskMitigationaArr) {
              if (model.seqNum === 2) {
                console.log({ riskMitigationaArr }, model.answer);
              }
              riskMitigationaArr.forEach((itm, idx) => {
                if (model.seqNum === 2) {
                  if (String((itm?.index || [])[0]) === String(model.answer)) {
                    model.riskMitigationaText = itm.text;
                  }
                } else if (itm.level === level) {
                  model.riskMitigationaText = itm.text;
                }
              });
            }

            data.subSectionComplexity[idx].questionComplexity[i] = {
              ...question,
              ...model,
            };
          }
        });
      });
    });

  if (executionAnswerArr.length > 0) {
    //  for complexity-BPSI answers showing.
    data.subSectionComplexity[1].questionComplexity[0].executionAnswerArr =
      executionAnswerArr;
  }
  if (level) {
    return { data, models };
  }
  return {};
};

export const formatReqRiskData = (formatData, section) => {
  const riskdata = formatData.risk;
  const res = Object.keys(riskdata).reduce((res, item) => {
    const index = Number(item.split('--')[0]);
    let level = item.split('--')[1];

    let optionIndex;
    if (index === 2) {
      optionIndex = {
        high: 2,
        null: 1,
        medium: 3,
      }[level];
    }

    if (level === 'null') {
      level = null;
    }

    const obj = res.find((itm) => itm.seqNum === index);

    if (obj) {
      obj.riskMitigation.push({
        level,
        text:
          typeof riskdata[item] !== 'string'
            ? JSON.stringify(riskdata[item])
            : riskdata[item],
        index: optionIndex && [String(optionIndex)],
      });
    } else {
      res.push({
        seqNum: index,
        riskMitigation: [
          {
            level,
            text: JSON.stringify(riskdata[item]),
            index: optionIndex && [String(optionIndex)],
          },
        ],
      });
    }

    return res;
  }, []);
  return { riskMitigationInfo: res };
};

export const formatReqData = (
  originData,
  formData,
  section,
  complexityModel,
) => {
  // debugger;
  const sectionIndex =
    QUES_SECTIONS_SEQ.findIndex((itm, idx) => itm === section) + 1;

  // let data = deepCopy(originData);
  const { models } = formatStrategyData(originData, complexityModel);
  const newData = {};
  newData.questionComplexity = [];
  newData.sectionNum = sectionIndex;
  for (const [k, v] of Object.entries(formData)) {
    if (k.includes('top')) {
      newData.complexityText = v;
    }
    if (k === 'sectionLevel') {
      newData.sectionLevel = v;
    }
    if (k === 'sectionLevelPercent') {
      newData.sectionLevelPercent = v;
    }
    if (k.includes('subSectionLevels')) {
      newData.subSectionLevelList = v;
    }
    if (k.includes('optionCriteria')) {
      const splitArr = k.split('--');
      const num = splitArr[1];
      const model = models.filter(
        (itm, idx) => Number(itm.seqNum) === Number(num),
      );

      let { seqNum, optionCriteriaArr, isCollapse, type, originAnswer } =
        model[0];
      if (typeof optionCriteriaArr === 'string') {
        optionCriteriaArr = JSON.parse(optionCriteriaArr);
      }
      if (seqNum !== 1) {
        optionCriteriaArr.forEach((item, idx) => {
          if (splitArr[2] === item.level) {
            item.text = !isCollapse
              ? JSON.stringify(v)
              : JSON.stringify(Object.values(v)[0]);
          }
        });
      } else {
        optionCriteriaArr.forEach((item, idx) => {
          if (Number(splitArr[2]) === Number(item.index[0])) {
            item.text = JSON.stringify(v);
          }
        });
      }

      const hasSeqNum = newData.questionComplexity.find(
        (item, idx) => item.seqNum === Number(num),
      );
      !hasSeqNum &&
        newData.questionComplexity.push({
          seqNum,
          optionText: optionCriteriaArr,
          type,
          answer: originAnswer,
        });
      hasSeqNum &&
        newData.questionComplexity.forEach((item, index) => {
          if (item.seqNum === num) {
            item.optionText = optionCriteriaArr;
          }
        });
    }
  }
  for (const [k, v] of Object.entries(formData)) {
    if (k.includes('answer')) {
      const splitArr = k.split('-');
      const num = splitArr[1];
      newData.questionComplexity.forEach((item, index) => {
        if (Number(item.seqNum) === Number(num)) {
          item.answer = {};
          if (typeof ANSWERTYPE[item.type] === 'string') {
            item.answer[ANSWERTYPE[item.type]] = v;
          } else {
            const p1 = ANSWERTYPE[item.type][0];
            const p2 = ANSWERTYPE[item.type][1];
            item.answer[p1] = v;
            item.answer[p2] = '';
          }
        }
        // delete item.type;
      });
    }
  }
  return newData;
};

export const getLevelStringByPercent = (percent, defaultValue = 'low') => {
  if (typeof percent !== 'number') {
    console.warn('argument should be a number');
    return defaultValue;
  }
  if (percent <= 0.333333) {
    return 'low';
  } else if (percent > 0.333333 && percent <= 0.666666) {
    return 'medium';
  }
  return 'high';
};

const LevelStringToPercent = {
  low: 0,
  medium: 0.5,
  med: 0.5,
  high: 1,
};
export const getPercentByLevelString = (levelString, defaultValue = 0) =>
  LevelStringToPercent[levelString] || defaultValue;

export const clipFloat = (number, decPoints = 4) => {
  if (typeof number !== 'number') {
    console.warn('First argument should be a number');
    return 0;
  }
  const ratioNum = Math.pow(10, decPoints);
  return Math.floor(ratioNum * number) / ratioNum;
};

const formatSectionItem = (
  isLevel,
  isSummary,
  item = {},
  sectionNum,
  value,
) => {
  const sectionItem = {
    levelPercent: 0,
    level: 'low',
    summary: {},
    ...item,
    sectionNum,
  };
  if (isLevel) {
    sectionItem.levelPercent = clipFloat(value);
    sectionItem.level = getLevelStringByPercent(value);
  } else if (isSummary) {
    sectionItem.summary = value;
  }
  return sectionItem;
};

export const formatOverallComplexityRequestBody = (formData) => {
  const result = {};
  if (formData) {
    result.overallLevel = getLevelStringByPercent(formData.level);
    result.overallLevelPercent = clipFloat(formData.level);
    Object.entries(formData).forEach(([key, value]) => {
      const isLevel = key.includes(SECTION_LEVEL_PREFIX);
      const isSummary = key.includes(SECTION_SUMMARY_PREFIX);
      if (isLevel || isSummary) {
        const splitKeys = key.split('-');
        const sectionNum = parseInt(splitKeys[splitKeys.length - 1]);
        if (!result.sectionLevelList) {
          result.sectionLevelList = [];
          result.sectionLevelList.push(
            formatSectionItem(isLevel, isSummary, {}, sectionNum, value),
          );
        } else {
          const sectionIndex = result.sectionLevelList.findIndex(
            (i) => i.sectionNum === sectionNum,
          );
          if (sectionIndex >= 0) {
            result.sectionLevelList[sectionIndex] = formatSectionItem(
              isLevel,
              isSummary,
              result.sectionLevelList[sectionIndex],
              sectionNum,
              value,
            );
          } else {
            result.sectionLevelList.push(
              formatSectionItem(isLevel, isSummary, {}, sectionNum, value),
            );
          }
        }
      }
    });
  }
  return result;
};

export const formatOverallComplexityResponse = (originData = {}) => {
  if (!originData) {
    return;
  }
  const { sectionComplexity } = originData;
  if (Array.isArray(sectionComplexity)) {
    sectionComplexity.forEach((sectionItem) => {
      if (
        Array.isArray(sectionItem.summary) &&
        sectionItem.summary.every((i) => !i?.key)
      ) {
        sectionItem.summary = {
          blocks: sectionItem.summary.map((j) => ({ ...j, key: genKey() })),
          entityMap: {},
        };
      }
    });
  }
  return originData;
};
